export default __webpack_public_path__ + "static/media/icon-analises-credito.2687049b.svg";